import Icon from '../components/Icon.vue'

Icon.register({
  'laptop-medical': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M232 224c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56zM576 48v336h-512v-336c0.1-26.4 21.6-47.9 48-48h416c26.4 0.1 47.9 21.6 48 48zM512 320v-256h-384v256h384zM624 416c8.8 0 16 7.2 16 16v16c-0.1 35.2-28.8 63.9-64 64h-512c-35.2-0.1-63.9-28.8-64-64v-16c0-8.8 7.2-16 16-16h239.2c-0.2 14.5 14.1 32 32.8 32h60.8c18 0 32-12.2 32.7-32h242.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laptop-medical.js
// module id = 1506
// module chunks = 0